module.exports = __webpack_public_path__ + "assets/img/7af24bd656ec7eb8cbae547dd87e8109.png";